import { Injectable } from '@angular/core';

import { AppConfig } from "../../app/app.config";
import { ApiService } from "../api-service/api-service";


@Injectable()
export class OrderService {

  constructor(public api: ApiService) {

  }


  //创建订单
  addOrder(accountInfo: any)
  {
    let url = 'v1/order';
    if(accountInfo.order_id != '') {
      url = 'v1/reorder';
    }

    let seq = this.api.post(url, accountInfo).share();
    seq.subscribe((res: any) => {
      if(res.code>0)
      {
        AppConfig.cartNeedFresh = true;
      }
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  //微信统一下单
  addWXOrder(accountInfo: any)
  {
    let seq = this.api.post('v1/wxpay', accountInfo).share();
    seq.subscribe((res: any) => {
      if(res.code>0)
      {
        AppConfig.cartNeedFresh = true;
      }
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 订单列表
   */
  getOrders(accountInfo: any)
  {
    let seq = this.api.get('v1/order', accountInfo).share();
    seq.subscribe((res:any) =>
    {
      if(res.code>0)
      {
        AppConfig.cartNeedFresh = false;
      }
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 修改订单
   */
  changeOrder(accountInfo: any)
  {
    accountInfo.id = 'id';
    let seq = this.api.put('v1/order/id', accountInfo).share();
    seq.subscribe((res:any) =>
    {
      if(res.code>0)
      {
        AppConfig.cartNeedFresh = false;
      }
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 查看物流
   */
  changeExpressage(accountInfo: any)
  {
    let seq = this.api.get('v1/expressage', accountInfo).share();
    seq.subscribe((res:any) =>
    {
      console.log('expressage');
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  // 获取订单详情 get
  getOrderDetail(accountInfo: any) {
    let seq = this.api.get('v1/order', accountInfo).share();
    seq.subscribe((res:any) =>
    {
      if(res.code>0)
      {
        AppConfig.cartNeedFresh = false;
      }
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 获取物流信息 get
  getSaleTrack(accountInfo: any) {
    let seq = this.api.get('v1/order/sale/track', accountInfo).share();
    seq.subscribe((res:any) => {
      if(res.code>0)
      {
        AppConfig.cartNeedFresh = false;
      }
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

}



// WEBPACK FOOTER //
// ./src/providers/data-service/order-service.ts